import styled from "styled-components";


// FOR BUDGET AND TIME
export const BudgetAndTimeContainer = styled.div`
  background-color: #FAFAFA;
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  //background: darkred;
`
export const NameSectionBudgetAndTime = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 80%;
  h2 {
    width: 90%;
    text-align: left;
  }
`
export const WrapperBudgetAndTime = styled.div`
  display: flex;
  justify-content: space-around;
  width: 80%;
  gap: 0.5em;
`

export const CascadeItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 0 0 3rem;
  gap: 1.2rem;
`

export const CascadeItem = styled.div`
  background-color: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  justify-content: center;
  padding: 0.5em;
  cursor: pointer;
  
  &:hover {
    background: var(--color-grey-03)
  }

`
export const CascadeMessage = styled.div`

  padding: 0.5rem;
  text-align: center;
  font-style: oblique;
  font-size: 16px;
`

